<ng-container *ngIf="constant.isIfreameLodded || name === 'lobby'">
  <div class="background-disabled">
    <div class="loader-new-for-iframe p-0 position-absolute">
      <!-- <h2 >SUPERNOWA</h2> -->
      <img src="assets/images/logo/supernowa-logo.gif" alt="loader">
    </div>
  </div>
</ng-container>